import { gql } from 'apollo-angular'

import { ORGANIZATION_RESELLER_REQUEST_FIELDS } from '../../fragments/organization-reseller-request.fragment'

export const GET_ORGANIZATION_RESELLER_REQUESTS = gql`
  query GetOrganizationResellerRequests(
    $page: Int
    $limit: Int
    $where: OrganizationResellerRequest_where
  ) {
    OrganizationResellerRequests(
      page: $page
      limit: $limit
      sort: "-createdAt"
      where: $where
    ) {
      totalDocs
      totalPages
      page
      docs {
        ...OrganizationResellerRequestFields
      }
    }
  }
  ${ORGANIZATION_RESELLER_REQUEST_FIELDS}
`
